import { useState } from "react";

import FormInput from "../form-input/form-input.component";
import Button, { BUTTON_TYPE_CLASSES } from "../button/button.component";
import { ToastContainer, toast } from "react-toastify";

import {
  signInAuthUserWithEmailAndPassword,
  signInWithGooglePopup,
} from "../../utils/firebase/firebase.utils";
import { useNavigate } from "react-router-dom";

import {
  SignUpContainer,
  FormContainer,
  WelcomeText,
  ButtonContainer,
  HorizontalRule,
  SignUpPage,
} from "./sign-up-form.styles";
import AnimationPage from "../smallcomponents/animation.component";

const defaultFormFields = {
  email: "",
  password: "",
};

const SignInForm = () => {
  const [formFields, setFormFields] = useState(defaultFormFields);
  const { email, password } = formFields;

  const navigate = useNavigate();

  const onNavigateHandler = () => {
    navigate("/auth/sign-up");
  };

  const resetFormFields = () => {
    setFormFields(defaultFormFields);
  };

  const signInWithGoogle = async () => {
    await signInWithGooglePopup();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await signInAuthUserWithEmailAndPassword(email, password);
      resetFormFields();
      toast.info("Welcome back! You have successfully logged in.");
    } catch (error) {
      switch (error.code) {
        case "auth/wrong-password":
          toast.error("Incorrect password. Please try again.");
          break;
        case "auth/user-not-found":
          toast.error("User not found. Please check your email and try again.");
          break;
        case "auth/invalid-email":
          toast.error("Invalid email. Please check your email and try again.");
          break;
        default:
          toast.error("An error occurred. Please try again later.");
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormFields({ ...formFields, [name]: value });
  };

  return (
    <>
      <AnimationPage>
        <SignUpContainer>
          <FormContainer
            onSubmit={handleSubmit}
            className="form"
            autoComplete="new-password"
          >
            <WelcomeText>Sign in with your email and password</WelcomeText>

            <div>
              <FormInput
                label="Email"
                type="email"
                required
                onChange={handleChange}
                name="email"
                value={email}
              />

              <FormInput
                label="Password"
                type="password"
                required
                onChange={handleChange}
                name="password"
                value={password}
              />
            </div>
            <ButtonContainer>
              <Button type="submit">Sign In</Button>
              <Button
                buttonType={BUTTON_TYPE_CLASSES.google}
                type="button"
                onClick={signInWithGoogle}
              >
                Sign in by Google
              </Button>
            </ButtonContainer>
            <HorizontalRule />
            <SignUpPage>
              <p>Don't have an existing account?</p>
              <Button
                buttonType={BUTTON_TYPE_CLASSES.animated}
                onClick={onNavigateHandler}
              >
                Sign-up
              </Button>
            </SignUpPage>
          </FormContainer>
        </SignUpContainer>
      </AnimationPage>
      <ToastContainer />
    </>
  );
};

export default SignInForm;
